// @vendor
const React = require("react");
const PropTypes = require("prop-types");
const { withRouter } = require("react-router-dom");

// @common
const Wizard = require("components/commons/wizard/wizard");
const WizardStep = require("components/commons/wizardStep/wizardStep");

// @components
const PreGrantedCreditSidebar = require("../preGrantedCreditSidebar/preGrantedCreditSidebar");
const PreGrantedCreditStepOne = require("../preGrantedCreditStepOne/preGrantedCreditStepOne");
const PreGrantedCreditStepTwo = require("../preGrantedCreditStepTwo/preGrantedCreditStepTwo");
const PreGrantedCreditStepThree = require("../preGrantedCreditStepThree/preGrantedCreditStepThree");
const PreGrantedCreditStepFour = require("../preGrantedCreditStepFour/preGrantedCreditStepFour");
const PreGrantedCreditSuccess = require("../preGrantedCreditSuccess/preGrantedCreditSuccess");
const PreGrantedCreditError = require("../preGrantedCreditError/preGrantedCreditError");
const ContractAsnefError = require('../../contractAsnefError/contractAsnefError');
const { CallMeBack } = require("components/callMeBack/callMeBack");
//@utilities
const PersonalDataHelper = require("utilities/personalDataHelper");
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @core
const { formatText } = require("core/i18n").i18n;

//@constants
const {
    PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL
} = require("constants/flagBasedFeatures");
const {
    catalogue,
    analyticsId,
} = require("../analytics/preGrantedCreditAnalytics");

class PreGrantedCreditWizard extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    getAccount() {
        const { immAccounts, immPreGrantedCredit } = this.props;

        return immAccounts.getIn([
            "byId",
            immPreGrantedCredit.get("selectedAccount"),
        ]);
    }

    buildSidebar() {
        const { immAccounts, immPreGrantedCredit } = this.props;
        return (
            <PreGrantedCreditSidebar
                immAccounts={immAccounts}
                immPreGrantedCredit={immPreGrantedCredit}
            />
        );
    }

    buildCallMe() {
        return <CallMeBack context="contracts" modifier="contracts-view" />;
    }

    buildContent() {
        const sidebar = this.buildSidebar();
        const mainContent = this.buildWizard();
        const callme = this.buildCallMe();

        return (
            <div className="pre-granted-credit-wizard__content row">
                <div className="col-xs-8">{mainContent}</div>
                <div className="col-xs-4">
                    {sidebar}
                    {callme}
                </div>
            </div>
        );
    }

    buildStepOne() {
        const {
            getContractInformation,
            immPreGrantedCredit,
            immProfile,
            preContractualMail,
            requestProfile,
            resetPrecontractualMail,
            sendPreContractualMail,
            updateConfirmationCheckbox,
            immFlagBasedFeatures,
            sendOverDraftSimpleEmail,
        } = this.props;
        return (
            <PreGrantedCreditStepOne
                getContractInformation={getContractInformation}
                immPreGrantedCredit={immPreGrantedCredit}
                immProfile={immProfile}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                resetPrecontractualMail={resetPrecontractualMail}
                sendPreContractualMail={sendPreContractualMail}
                updateConfirmationCheckbox={updateConfirmationCheckbox}
                immFlagBasedFeatures={immFlagBasedFeatures}
                sendOverDraftSimpleEmail={sendOverDraftSimpleEmail}
            />
        );
    }

    buildStepTwo() {
        const {
            getBlockedAccounts,
            immAccounts,
            immFlagBasedFeatures,
            immPreGrantedCredit,
            sendLoansBarePrecontractualEmail,
            setLoanAmount,
            setSelectedAccount,
            setInitApiFlag,
            onAgreeReset,
            onAgreeCheckbox,
            officePrintReset,
            resetMailSent
        } = this.props;
        return (
            <PreGrantedCreditStepTwo
                getBlockedAccounts={getBlockedAccounts}
                immAccounts={immAccounts}
                immFlagBasedFeatures={immFlagBasedFeatures}
                immPreGrantedCredit={immPreGrantedCredit}
                sendLoansBarePrecontractualEmail={
                    sendLoansBarePrecontractualEmail
                }
                setLoanAmount={setLoanAmount}
                setSelectedAccount={setSelectedAccount}
                setInitApiFlag={setInitApiFlag}
                onAgreeReset={onAgreeReset}
                onAgreeCheckbox={onAgreeCheckbox}
                officePrintReset={officePrintReset}
                resetMailSent={resetMailSent}
            />
        );
    }

    buildStepThree() {
        const {
            getContractInformation,
            immProfile,
            preContractualMail,
            requestProfile,
            getINEDocument,
            getContractDraftDocument,
            resetPrecontractualMail,
            sendPreContractualMail,
            updateConfirmationCheckbox,
            immFlagBasedFeatures,
            getHiringDocuments,
            immPreGrantedCredit,
            onAgreeCheckbox,
            onAgreeReset,
            onDownload,
            onPrint,
            sendOverDraftSimpleEmail,
            getOverdraftInitOne,
            checkRadioButtonOfficeStepThree,
            getOverdraftInitTwo
        } = this.props;
        const immAccount = this.getAccount();

        return (
            <PreGrantedCreditStepThree
                getHiringDocuments={getHiringDocuments}
                getOverdraftInitOne={getOverdraftInitOne}
                immAccount={immAccount}
                immPreGrantedCredit={immPreGrantedCredit}
                immFlagBasedFeatures={immFlagBasedFeatures}
                onAgreeCheckbox={onAgreeCheckbox}
                onAgreeReset={onAgreeReset}
                sendOverDraftSimpleEmail={sendOverDraftSimpleEmail}
                onDownload={onDownload}
                getContractInformation={getContractInformation}
                immProfile={immProfile}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                resetPrecontractualMail={resetPrecontractualMail}
                sendPreContractualMail={sendPreContractualMail}
                updateConfirmationCheckbox={updateConfirmationCheckbox}
                onPrint={onPrint}
                getINEDocument={getINEDocument}
                getContractDraftDocument={getContractDraftDocument}
                getOverdraftInitTwo={getOverdraftInitTwo}
                checkRadioButtonOfficeStepThree={checkRadioButtonOfficeStepThree}
            />
        );
    }
    buildStepFour() {
        const {
            getContractInformation,
            immProfile,
            preContractualMail,
            requestProfile,
            getINEDocument,
            getContractDraftDocument,
            resetPrecontractualMail,
            sendPreContractualMail,
            updateConfirmationCheckbox,
            immFlagBasedFeatures,
            getHiringDocuments,
            immPreGrantedCredit,
            onAgreeCheckbox,
            onAgreeReset,
            onDownload,
            onPrint,
            sendOverDraftSimpleEmail,
            getOverdraftInitOne,
            getOverdraftInitTwo,
            checkRadioButtonOfficeStepFour
        } = this.props;
        const immAccount = this.getAccount();

        return (
            <PreGrantedCreditStepFour
                getHiringDocuments={getHiringDocuments}
                getOverdraftInitOne={getOverdraftInitOne}
                getOverdraftInitTwo={getOverdraftInitTwo}
                immAccount={immAccount}
                immPreGrantedCredit={immPreGrantedCredit}
                immFlagBasedFeatures={immFlagBasedFeatures}
                onAgreeCheckbox={onAgreeCheckbox}
                onAgreeReset={onAgreeReset}
                sendOverDraftSimpleEmail={sendOverDraftSimpleEmail}
                onDownload={onDownload}
                getContractInformation={getContractInformation}
                immProfile={immProfile}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                resetPrecontractualMail={resetPrecontractualMail}
                sendPreContractualMail={sendPreContractualMail}
                updateConfirmationCheckbox={updateConfirmationCheckbox}
                onPrint={onPrint}
                getINEDocument={getINEDocument}
                getContractDraftDocument={getContractDraftDocument}
                checkRadioButtonOfficeStepFour={checkRadioButtonOfficeStepFour}
            />
        );
    }

    buildError(simpleEmailError) {
        if (simpleEmailError) {
            const title = "contractsView-preGrantedCreditSimpleMailErrorTitle"
            const message = "contractsView-preGrantedCreditSimpleMailError";
            const extra = "contractsView-errorContact";
            return (
                <PreGrantedCreditError
                    title={title}
                    message={message}
                    extra={!__CONTACT_CENTER__ ? extra : ''}
                />
            );
        }
        return <PreGrantedCreditError />;
    }

    buildErrorFormalize() {
        const title = "contractsView-preGrantedCreditErrorTitle";
        const message = "contractsView-preGrantedCreditErrorMsg";
        const extra = "contractsView-errorContact";

        return (
            <PreGrantedCreditError
                title={title}
                message={message}
                extra={extra}
            />
        );
    }
    buildAsnefError(immPreGrantedCredit) {
        return (
            <ContractAsnefError
                errorValue={immPreGrantedCredit.get('selectedAmount')}
                history={this.props.history}
            />
        );
    }
    buildSuccess() {
        const { immPreGrantedCredit, immProfile, immFlagBasedFeatures } =
            this.props;
        const immAccount = this.getAccount();
        const email = PersonalDataHelper.getEmail(immProfile);

        return (
            <PreGrantedCreditSuccess
                immFlagBasedFeatures={immFlagBasedFeatures}
                email={email}
                immAccount={immAccount}
                immPreGrantedCredit={immPreGrantedCredit}
            />
        );
    }

    buildPreLeaveModalConfig() {
        return {
            message: formatText("wizard-redirectConfirmationMessage"),
            title: formatText("wizard-redirectConfirmationTitle"),
            leftButtonConfig: {
                text: formatText("wizard-redirectConfirmationAcceptButton"),
                redirect: true,
            },
            rightButtonConfig: {
                text: formatText("wizard-redirectConfirmationCancelButton"),
            },
        };
    }

    handleCancel() {
        this.props.history.push("/myprofile/loans-mortgages");
    }

    buildWizard() {
        const {
            formalize,
            immPreGrantedCredit,
            validateStep,
            setVisibleStep,
            immFlagBasedFeatures,
            setInitApiFlag
        } = this.props;
        const immSteps = __CONTACT_CENTER__ && !isPrintOfficeMode()
            ? immPreGrantedCredit.get("steps")
            : immPreGrantedCredit.get("fourSteps");
        const visibleStep = immPreGrantedCredit.get("visibleStep");
        const isFetchingStepThree = immPreGrantedCredit.get(
            "isFetchingFormalize"
        );
        const cancelButtonText = formatText("common-cancel");
        const successDraftDocument = immPreGrantedCredit.get(
            "successDraftDocument"
        );
        const stepTwoComponent = this.buildStepTwo();
        const preleaveModalConfig = this.buildPreLeaveModalConfig();
        const preGrantedCreditCCFlag = !!(
            (__CONTACT_CENTER__ &&
                immFlagBasedFeatures.get(PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL) &&
                visibleStep === 1) ||
            visibleStep === 3
        );
        const actions = {
            cancel: this.handleCancel,
            finish: formalize,
            validateStep,
            setVisibleStep,
            setWillCancel: () => {
                return false;
            },
            setWillGoBack: () => {
                return false;
            },
            resetStep: () => {
                (__CONTACT_CENTER__ && !isPrintOfficeMode() && !immPreGrantedCredit.get('isOverdraftEmailSent')) ?
                    setInitApiFlag(false, immPreGrantedCredit.get('mailAPIFlag'), immPreGrantedCredit.get('checkboxFlag'), false) :
                    setInitApiFlag(false, false, true, false);
            },
        };
        const tealiumData = [
            catalogue[analyticsId.PRE_GRANTED_CREDIT_STEP_1_VIEW](),
            catalogue[analyticsId.PRE_GRANTED_CREDIT_STEP_2_VIEW](),
            catalogue[analyticsId.PRE_GRANTED_CREDIT_STEP_3_VIEW](),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.PRE_GRANTED_CREDIT_STEP_1_SUCCESS](),
            catalogue[analyticsId.PRE_GRANTED_CREDIT_STEP_2_SUCCESS](),
        ];
        return (isPrintOfficeMode() || (!__CONTACT_CENTER__ && !isPrintOfficeMode()))
            ? (
                <Wizard
                    immSteps={immSteps}
                    stepsAmount={immSteps.size}
                    visibleStep={visibleStep}
                    actions={actions}
                    preleaveModalMessage={preleaveModalConfig.message}
                    preleaveModalTitle={preleaveModalConfig.title}
                    preleaveModalLeftButtonConfig={
                        preleaveModalConfig.leftButtonConfig
                    }
                    preleaveModalRightButtonConfig={
                        preleaveModalConfig.rightButtonConfig
                    }
                    showPreLeaveModal
                    tealium={tealiumData[visibleStep - 1]}
                    tealiumEvents={{
                        next: { ...tealiumEvents[visibleStep - 1], data: true },
                    }}
                    isTaggingSecondVersion
                >
                    <WizardStep
                        nextButton
                        position="first"
                        cancelButtonText={cancelButtonText}
                        cancelButton
                        nextButtonDisabled={
                            preGrantedCreditCCFlag
                                ? __CONTACT_CENTER__ &&
                                !immPreGrantedCredit.get("confirmationCheckbox")
                                : false
                        }
                    >
                        {this.buildStepOne()}
                    </WizardStep>
                    <WizardStep
                        nextButton
                        position="middle"
                        cancelButtonText={cancelButtonText}
                        cancelButton
                    >
                        {stepTwoComponent}
                    </WizardStep>
                    <WizardStep
                        nextButton
                        nextButtonDisabled={isPrintOfficeMode()
                            ? (!immPreGrantedCredit.get('officePrintStepThree') || !immPreGrantedCredit.get('documentSignedRadioButtonStepThree'))
                            : (!immPreGrantedCredit.get('agree') || immPreGrantedCredit.get('btnFlag'))
                        }
                        position="middle"
                        cancelButtonText={cancelButtonText}
                        cancelButton
                    >
                        {this.buildStepThree()}
                    </WizardStep>
                    <WizardStep
                        officeSignature={isPrintOfficeMode()}
                        position="last"
                        immFinalButton="contractsView-contratar"
                        isLoading={isFetchingStepThree}
                        cancelButtonText={cancelButtonText}
                        addLoadingBehaviour
                        cancelButton
                        finalButtonDisabled={
                            (!__CONTACT_CENTER__ && !successDraftDocument) ||
                            (__CONTACT_CENTER__ && !isPrintOfficeMode() && !immPreGrantedCredit.get("confirmationCheckbox")) ||
                            (!successDraftDocument) ||
                            (isPrintOfficeMode() && !immPreGrantedCredit.get('officePrintStepFour')) ||
                            (isPrintOfficeMode() && !immPreGrantedCredit.get('documentSignedRadioButtonStepFour'))
                        }
                    >
                        {this.buildStepFour()}
                    </WizardStep>
                </Wizard>
            ) : (<Wizard
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                actions={actions}
                preleaveModalMessage={preleaveModalConfig.message}
                preleaveModalTitle={preleaveModalConfig.title}
                preleaveModalLeftButtonConfig={
                    preleaveModalConfig.leftButtonConfig
                }
                preleaveModalRightButtonConfig={
                    preleaveModalConfig.rightButtonConfig
                }
                showPreLeaveModal
                tealium={tealiumData[visibleStep - 1]}
                tealiumEvents={{
                    next: { ...tealiumEvents[visibleStep - 1], data: true },
                }}
                isTaggingSecondVersion
            >
                <WizardStep
                    nextButton
                    position="first"
                    cancelButtonText={cancelButtonText}
                    cancelButton
                    nextButtonDisabled={
                        preGrantedCreditCCFlag
                            ? __CONTACT_CENTER__ &&
                            !immPreGrantedCredit.get("confirmationCheckbox")
                            : false
                    }
                >
                    {this.buildStepOne()}
                </WizardStep>
                <WizardStep
                    nextButton
                    position="middle"
                    cancelButtonText={cancelButtonText}
                    cancelButton
                >
                    {stepTwoComponent}
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="contractsView-contratar"
                    isLoading={isFetchingStepThree}
                    cancelButtonText={cancelButtonText}
                    addLoadingBehaviour
                    cancelButton
                    finalButtonDisabled={
                        (!__CONTACT_CENTER__ && !successDraftDocument) ||
                        (__CONTACT_CENTER__ && !immPreGrantedCredit.get("confirmationCheckbox")) ||
                        (!successDraftDocument)
                    }
                >
                    {this.buildStepThree()}
                </WizardStep>
            </Wizard>
            );
    }

    render() {
        const { immPreGrantedCredit } = this.props;
        const success = immPreGrantedCredit.get('success');
        const error = immPreGrantedCredit.get('error');
        const asnefError = immPreGrantedCredit.get('asnefError');
        const errorFormalize = immPreGrantedCredit.get('errorFormalize');
        const isOverdraftEmailInitError = immPreGrantedCredit.get('isOverdraftEmailInitError');
        const simpleEmailError = immPreGrantedCredit.get('overdraftEmailError');
        const overdraftEmailLoading = immPreGrantedCredit.get('overdraftEmailLoading')
        const accountTinTaeError = immPreGrantedCredit.get('accountTinTaeError');
        let content;
        if (success) {
            content = this.buildSuccess();
        } else if (error || isOverdraftEmailInitError || accountTinTaeError) {
            content = this.buildError();
        } else if (simpleEmailError && !overdraftEmailLoading) {
            content = this.buildError(simpleEmailError);
        } else if (asnefError) {
            content = this.buildAsnefError(immPreGrantedCredit);
        } else if (errorFormalize) {
            content = this.buildErrorFormalize();
        } else if (!error || !isOverdraftEmailInitError || !accountTinTaeError || !overdraftEmailLoading) {
            content = this.buildContent();
        }

        return <div className="pre-granted-credit-wizard row">{content}</div>;
    }
}

PreGrantedCreditWizard.propTypes = {
    formalize: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPreGrantedCredit: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    getContractInformation: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    onAgreeCheckbox: PropTypes.func.isRequired,
    onAgreeReset: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendLoansBarePrecontractualEmail: PropTypes.func.isRequired,
    sendOverDraftSimpleEmail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    updateConfirmationCheckbox: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    getContractDraftDocument: PropTypes.func.isRequired,
    getOverdraftInitOne: PropTypes.func.isRequired,
    setInitApiFlag: PropTypes.func.isRequired,
    officePrintReset: PropTypes.func.isRequired,
    resetMailSent: PropTypes.func,
    checkRadioButtonOfficeStepThree: PropTypes.func,
    checkRadioButtonOfficeStepFour: PropTypes.func,
};

module.exports = withRouter(PreGrantedCreditWizard);
